import moment from "moment-timezone";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table } from "semantic-ui-react";

import { MediaAs } from "../../styles/Media.js";

import ResourceMarker from "../marking/ResourceMarker.jsx";
import ActionDropdownMenu from "../actionDropdownMenu/ActionDropdownMenu.jsx";
import withConfirmationModal from "../modals/withConfirmationModal.js";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { OPERATIONS } from "../../constants/operations.js";
import { MODIFIED_AT_TIME_FORMAT } from "../config.js";
import { AT_TYPES } from "../../constants/entity.js";
import { MARKING_STATES } from "../../utils/marking.js";

import { operationActionByType } from "../../state/reducers/operations/operationActions.js";
import { getResourceByAtId } from "../../state/reducers/resources/resourcesActions.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class UserList extends PureComponent {
  static propTypes = {
    entity: PropTypes.object,
    disabled: PropTypes.bool.isRequired,

    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,

    operationActionByType: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    viewInvite: false,
    disabled: false,
    copyKey: "users.user_panel"
  };

  // -- HANDLERS -- //

  handleDelete = activeImage => {
    const { entity, openModal, copyKey } = this.props;

    this.setState({ activeImage }, () => {
      openModal(
        this.doDelete,
        `${copyKey}.modals.delete_modal`,
        undefined,
        entity
      );
    });
  };

  doDelete = () => {
    const { entity, operationActionByType } = this.props;
    const { activeImage } = this.state;

    const user = entity.users.find(item => item["@id"] === activeImage);

    const successAction = getResourceByAtId(
      entity["@id"],
      entity["@type"],
      true,
      true,
      true
    );

    operationActionByType(entity["@type"], user, OPERATIONS.DELETE, undefined, {
      success: successAction
    });
  };

  // -- RENDER -- //

  getViewPath = item => {
    const { entity } = this.props;

    let viewPath = `${entity["@id"]}${item.subject["@id"]}`;

    if (entity.project) {
      viewPath = `${entity.project["@id"]}${item.subject["@id"]}`;
    }

    if (item.subject["@type"] === AT_TYPES.INVITEE) {
      if (item.marking !== MARKING_STATES.EXPIRED) {
        viewPath = item.invite["@id"];
      }
    }

    return viewPath;
  };

  renderUserRows = showGroups => {
    const { entity, copyKey, copy } = this.props;

    return entity.users.map(item => {
      const sudoCopyKey = item.sudo ? "admin" : "standard";
      const expiredAt =
        item.marking === MARKING_STATES.EXPIRED ? null : item.invite?.expiredAt;

      const viewPath = this.getViewPath(item);

      return (
        <Table.Row key={item["@id"]}>
          <Table.Cell>
            <LinkWithReset to={viewPath} className="table-link">
              {item.subject.email}
            </LinkWithReset>
          </Table.Cell>
          {showGroups && (
            <MediaAs greaterThan="smallTablet" as={Table.Cell} collapsing>
              {item.group.name}
            </MediaAs>
          )}
          <MediaAs greaterThan="smallTablet" as={Table.Cell} collapsing>
            {copy(`${copyKey}.sudo_roles.${sudoCopyKey}`)}
          </MediaAs>
          <MediaAs greaterThan="smallTablet" as={Table.Cell} collapsing>
            {expiredAt &&
              moment(item.invite.expiredAt).format(MODIFIED_AT_TIME_FORMAT)}
          </MediaAs>
          <Table.Cell collapsing>
            <ResourceMarker marking={item.marking} circular={true} />
          </Table.Cell>
          <Table.Cell collapsing>
            <ActionDropdownMenu
              data={item}
              viewPath={viewPath}
              onDelete={this.handleDelete}
              copy={copy("basic_resource_actions")}
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  render() {
    const { entity, copyKey, copy } = this.props;

    // bail early if base permissions are not met
    if (!entity || !entity.users) return null;

    if (entity.users.length < 1) {
      return <p>{copy(`${copyKey}.no_users`)}</p>;
    }

    const showGroups = entity.groups && entity.groups.length > 0;

    return (
      <Table disabled celled basic striped unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{copy(`${copyKey}.email`)}</Table.HeaderCell>
            {showGroups && (
              <MediaAs
                greaterThan="smallTablet"
                as={Table.HeaderCell}
                collapsing
              >
                {copy(`${copyKey}.group_label`)}
              </MediaAs>
            )}
            <MediaAs greaterThan="smallTablet" as={Table.HeaderCell} collapsing>
              {copy(`${copyKey}.sudo`)}
            </MediaAs>
            <MediaAs greaterThan="smallTablet" as={Table.HeaderCell} collapsing>
              {copy(`${copyKey}.expires_at`)}
            </MediaAs>
            <Table.HeaderCell collapsing />
            <Table.HeaderCell collapsing />
          </Table.Row>
        </Table.Header>
        <Table.Body>{this.renderUserRows(showGroups)}</Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  operationActionByType: (...args) => dispatch(operationActionByType(...args))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withConfirmationModal(UserList));
